import { DialogComponent } from '@theme/dialog';


export class BackInStockModal extends DialogComponent {
  requiredRefs = ['dialog', 'form', 'emailInput', 'submitButton', 'messageContainer'];

  connectedCallback() {
    super.connectedCallback();
    this.refs?.form?.addEventListener('submit', this.handleSubmit.bind(this));
    this.KLAVIYO_PUBLIC_KEY = "TiH43r";
  }

  openModal(data) {
    this.productId = data.productId;
    this.variantId = data.variantId;
    this.productTitle = data.productTitle;
    this.variantTitle = data.variantTitle;
    this.productUrl = data.productUrl;

    const productTitleEl = this.refs?.productTitle;
    const variantTitleEl = this.refs?.variantTitle;

    if (productTitleEl) {
      productTitleEl.textContent = this.productTitle || '';
    }
    if (variantTitleEl) {
      variantTitleEl.textContent = this.variantTitle || '';
    }

    this.refs?.form?.reset();
    this.clearMessage();

    this.showDialog();
  }

  /**
   * @param {Event} event
   */
  async handleSubmit(event) {
    event.preventDefault();

    const emailInput = this.refs?.emailInput;
    const submitButton = this.refs?.submitButton;
    const email = emailInput.value.trim();

    if (!email) {
      this.showMessage('Please enter a valid email address.', 'error');
      return;
    }

    if (!this.productId || !this.variantId) {
      this.showMessage('Missing product or variant information.', 'error');
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = 'Submitting...';

    try {
      await this.subscribeToBackInStock(email);
      this.showMessage('Success! We\'ll notify you when this item is back in stock.', 'success');
      
      setTimeout(() => {
        this.closeDialog();
      }, 2000);
    } catch (error) {
      this.showMessage(error.message || 'Something went wrong. Please try again.', 'error');
    } finally {
      submitButton.disabled = false;
      submitButton.textContent = 'Notify Me';
    }
  }

  /**
   * @param {string} email
   */
  async subscribeToBackInStock(email) {
    const klaviyoPublicKey = this.KLAVIYO_PUBLIC_KEY;

    if (!klaviyoPublicKey) {
      throw new Error('Klaviyo public key is not configured.');
    }

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
              },
            },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${this.variantId}`,
            },
          },
        },
      },
    };

    const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${klaviyoPublicKey}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2025-10-15',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.errors?.[0]?.detail || 'Failed to subscribe. Please try again.');
    }

    return true
  }

  /**
   * @param {string} message
   * @param {'success' | 'error'} type
   */
  showMessage(message, type) {
    const messageContainer = this.refs?.messageContainer;
    messageContainer.textContent = message;
    messageContainer.className = `bis-modal__message bis-modal__message--${type}`;
    messageContainer.style.display = 'block';
  }

  clearMessage() {
    const messageContainer = this.refs?.messageContainer;
    messageContainer.textContent = '';
    messageContainer.style.display = 'none';
  }
}

if (!customElements.get('back-in-stock-modal')) {
  customElements.define('back-in-stock-modal', BackInStockModal);
}
